module.exports = __webpack_public_path__ + "static/two-5c440ac9081686de1d71dd8692ce7f9f.png";